<template>
    
    <LoadingState v-if="loading"/>
    <Transition name="menu-sheet">
        <div v-if="menuExpanded" class="menu-backdrop" @click="closeMenu">
            <div class="menu-sheet" role="dialog" aria-modal="true" aria-label="Меню карточки" @click.stop>
                <div class="menu-sheet-handle" aria-hidden="true"></div>
                <div class="menu-sheet-header">
                    <div>
                        <div class="menu-sheet-title">EWERT</div>
                        <div class="menu-sheet-subtitle">Действия с карточкой</div>
                    </div>
                    <button type="button" class="menu-close" aria-label="Закрыть меню" @click="closeMenu">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="m6.4 5.3 5.6 5.6 5.6-5.6 1.1 1.1-5.6 5.6 5.6 5.6-1.1 1.1-5.6-5.6-5.6 5.6-1.1-1.1 5.6-5.6-5.6-5.6 1.1-1.1Z" fill="currentColor"/>
                        </svg>
                    </button>
                </div>
                <div class="menu-content">
                    <button v-if="canShareCard" type="button" class="menu-link" @click="shareCardPage">
                        <span>Поделиться карточкой</span>
                        <svg width="18" height="18" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.9015 2.66651C6.9015 1.74651 7.6515 1.00001 8.5755 1.00001C8.79489 0.999414 9.01225 1.04206 9.21516 1.1255C9.41806 1.20894 9.60254 1.33155 9.75804 1.48631C9.91355 1.64107 10.037 1.82496 10.1214 2.02746C10.2059 2.22996 10.2495 2.44711 10.25 2.66651C10.25 3.58701 9.5 4.33351 8.5755 4.33351C8.35381 4.33367 8.13429 4.28982 7.92967 4.20451C7.72506 4.11919 7.53941 3.99411 7.3835 3.83651L5.066 5.41451C5.13042 5.73601 5.09877 6.06937 4.975 6.37301L7.516 8.04301C7.81537 7.79907 8.18983 7.66606 8.576 7.66651C8.79539 7.66598 9.01274 7.70869 9.21562 7.79219C9.4185 7.87569 9.60294 7.99835 9.75839 8.15316C9.91385 8.30797 10.0373 8.49189 10.1216 8.69442C10.206 8.89695 10.2496 9.11411 10.25 9.33351C10.25 10.2535 9.5 11 8.5755 11C8.35615 11.0005 8.13885 10.9578 7.936 10.8744C7.73315 10.7909 7.54873 10.6683 7.39328 10.5135C7.23783 10.3588 7.11439 10.1749 7.03001 9.97244C6.94563 9.76997 6.90196 9.55286 6.9015 9.33351C6.90111 9.09982 6.95037 8.86872 7.046 8.65551L4.525 7.00001C4.21961 7.2653 3.82853 7.41111 3.424 7.41051C3.20461 7.41103 2.98726 7.36832 2.78438 7.28482C2.5815 7.20132 2.39706 7.07866 2.24161 6.92385C2.08615 6.76904 1.96272 6.58512 1.87836 6.38259C1.79401 6.18006 1.75039 5.9629 1.75 5.74351C1.75046 5.52416 1.79413 5.30705 1.87851 5.10458C1.96289 4.9021 2.08633 4.71824 2.24178 4.56348C2.39723 4.40873 2.58165 4.28611 2.7845 4.20264C2.98735 4.11917 3.20465 4.07648 3.424 4.07701C3.956 4.07701 4.429 4.32351 4.7355 4.70751L6.982 3.17801C6.92841 3.01281 6.90125 2.84018 6.9015 2.66651Z" fill="#ACE715"/>
                            </svg>

                    </button>
                    <a href="https://ewertcards.com/" class="menu-link" target="_blank" rel="noopener noreferrer">
                        <span>Сделать такую визитку</span>
                        <svg width="18" height="18" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" d="M1 6C1 3.643 1 2.4645 1.732 1.732C2.465 1 3.643 1 6 1C8.357 1 9.5355 1 10.2675 1.732C11 2.465 11 3.643 11 6C11 8.357 11 9.5355 10.2675 10.2675C9.536 11 8.357 11 6 11C3.643 11 2.4645 11 1.732 10.2675C1 9.536 1 8.357 1 6Z" fill="#ACE715"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.23498 5.765C6.16475 5.69469 6.12531 5.59938 6.12531 5.5C6.12531 5.40062 6.16475 5.30531 6.23498 5.235L10.095 1.375H8.32798C8.22852 1.375 8.13314 1.33549 8.06281 1.26517C7.99248 1.19484 7.95298 1.09946 7.95298 1C7.95298 0.900544 7.99248 0.805161 8.06281 0.734835C8.13314 0.664509 8.22852 0.625 8.32798 0.625H11C11.0994 0.625 11.1948 0.664509 11.2651 0.734835C11.3355 0.805161 11.375 0.900544 11.375 1V3.672C11.375 3.77146 11.3355 3.86684 11.2651 3.93717C11.1948 4.00749 11.0994 4.047 11 4.047C10.9005 4.047 10.8051 4.00749 10.7348 3.93717C10.6645 3.86684 10.625 3.77146 10.625 3.672V1.905L6.76498 5.765C6.69466 5.83523 6.59935 5.87467 6.49998 5.87467C6.4006 5.87467 6.30529 5.83523 6.23498 5.765Z" fill="#ACE715"/>
                        </svg>

                    </a>
                    <a href="https://ewertcards.com/faq" class="menu-link" target="_blank" rel="noopener noreferrer">
                        <span>О компании</span>
                        <svg width="18" height="18" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" d="M1 6C1 3.643 1 2.4645 1.732 1.732C2.465 1 3.643 1 6 1C8.357 1 9.5355 1 10.2675 1.732C11 2.465 11 3.643 11 6C11 8.357 11 9.5355 10.2675 10.2675C9.536 11 8.357 11 6 11C3.643 11 2.4645 11 1.732 10.2675C1 9.536 1 8.357 1 6Z" fill="#ACE715"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.23498 5.765C6.16475 5.69469 6.12531 5.59938 6.12531 5.5C6.12531 5.40062 6.16475 5.30531 6.23498 5.235L10.095 1.375H8.32798C8.22852 1.375 8.13314 1.33549 8.06281 1.26517C7.99248 1.19484 7.95298 1.09946 7.95298 1C7.95298 0.900544 7.99248 0.805161 8.06281 0.734835C8.13314 0.664509 8.22852 0.625 8.32798 0.625H11C11.0994 0.625 11.1948 0.664509 11.2651 0.734835C11.3355 0.805161 11.375 0.900544 11.375 1V3.672C11.375 3.77146 11.3355 3.86684 11.2651 3.93717C11.1948 4.00749 11.0994 4.047 11 4.047C10.9005 4.047 10.8051 4.00749 10.7348 3.93717C10.6645 3.86684 10.625 3.77146 10.625 3.672V1.905L6.76498 5.765C6.69466 5.83523 6.59935 5.87467 6.49998 5.87467C6.4006 5.87467 6.30529 5.83523 6.23498 5.765Z" fill="#ACE715"/>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </Transition>
    
    <div class="not-found" v-if="failed">
        <div class="not-found-content">
            <div class="broken-card" aria-hidden="true">
                <img src="@/assets/branding/top_part_of_card.png" alt="" class="broken-card-part broken-card-part--top">
                <img src="@/assets/branding/bottom_part_of_card.png" alt="" class="broken-card-part broken-card-part--bottom">
            </div>
            <p>{{ failedMessage }}</p>
        </div>
        <a class="not-found-link" href="https://ewertcards.com/">ewertcards.com</a>
    </div>
    <Transition>
    
    <div class="card" v-if="!loading && !failed">
        <div ref="scrollable" class="scrollable" @scroll="stopListenHint()">
            <Transition>
                <span class="badge" ref="hint" v-if="hintActive">Листайте вниз</span>
            </Transition>
            <div class="menu" >
                <svg  class="logo" height="41" viewBox="0 0 316 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50.0762 0.0870559V8.98118H13.4918V15.9779H41.4193V24.4569H13.4918V32.1059H50.3727V41H0.74353V0.0870559H50.0762ZM135.455 0.0870559L122.291 41H105.393L94.6603 8.56612L83.8095 41H66.9107L53.3916 0.0870559H65.962L76.3977 31.6315L86.9521 0.0870559H103.554L114.049 31.8094L124.248 0.0870559H135.455ZM190.089 0.0870559V8.98118H153.505V15.9779H181.432V24.4569H153.505V32.1059H190.386V41H140.756V0.0870559H190.089ZM238.824 0.0870559C243.804 0.0870559 247.639 1.21364 250.327 3.46682C253.054 5.72 254.418 9.04047 254.418 13.4282C254.418 16.9068 253.588 19.7332 251.928 21.9073C250.268 24.0419 247.876 25.544 244.753 26.4136L255.9 41H241.136L230.641 27.2438H210.54V41H197.792V0.0870559H238.824ZM241.67 13.1318C241.67 11.6692 241.255 10.5426 240.425 9.752C239.595 8.96141 238.033 8.56612 235.74 8.56612H210.54V18.5868H235.74C238.033 18.5868 239.595 18.1718 240.425 17.3416C241.255 16.472 241.67 15.3059 241.67 13.8433V13.1318ZM257.581 9.92988V0.0870559H315.689V9.92988H292.979V41H280.231V9.92988H257.581Z" fill="currentColor"/>
                </svg>

                <div class="hamburger" @click="menu()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg>
                </div>
            </div>
            <div class="header">
                <img :src="cardAvatarUrl" onerror="this.src = 'https://storage.yandexcloud.net/card.ewertcards.com/avatar.svg'" class="avatar" alt="">
                <h1 style="display: inline-flex; align-items: center;">{{ cardData.firstName }} {{ cardData.lastName }}<span v-if="cardData.nameEmoji" class="name-emoji">{{ cardData.nameEmoji }}</span>
                <span v-if="cardData.owner == '69824deea143aa20df000831'">
                    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.0498 14.8498V0.549805M0.549805 4.9498H11.5498" stroke="#ACE715" stroke-width="1.1" stroke-linecap="round"/>
                    </svg>
                </span>
                
                    <svg v-if="cardData.owner == '6a34bba020d62da177e689a1'" style="margin-left: 5px;" width="20" height="20" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.875 7.875V9H6.75V10.125H5.625V11.25H4.5V12.375H3.375V14.625H4.5V15.75H5.625V16.875H6.75V18H7.875V19.125H5.625V18H4.5V16.875H3.375V15.75H2.25V14.625H1.125V12.375H2.25V11.25H3.375V10.125H4.5V9H5.625V7.875H7.875ZM16.875 3.375H18V6.75H16.875V10.125H15.75V13.5H14.625V15.75H13.5V19.125H12.375V22.5H11.25V23.625H10.125V20.25H11.25V16.875H12.375V13.5H13.5V11.25H14.625V7.875H15.75V4.5H16.875V3.375ZM25.875 12.375V14.625H24.75V15.75H23.625V16.875H22.5V18H21.375V19.125H19.125V18H20.25V16.875H21.375V15.75H22.5V14.625H23.625V12.375H22.5V11.25H21.375V10.125H20.25V9H19.125V7.875H21.375V9H22.5V10.125H23.625V11.25H24.75V12.375H25.875Z" fill="#ACE715"/>
                    </svg>
                
                </h1>
                
                <span class="bio">{{ cardData.bio }}</span>
            </div>
            <div class="ordered-sections">
            <section v-if="cardData.description" :style="getSectionOrderStyle('about')">
                <div class="content aboutme">
                    <p>{{ cardData.description }}</p>
                    
                </div>
                
            </section>
            <section v-if="hasPersonalDetails" :style="getSectionOrderStyle('personal')">
                <div class="content personal-section">
                    <span>Личное</span>
                    <div class="profile-facts">
                        <div v-for="fact in profileFacts" :key="fact.key" class="profile-fact">
                            <span class="profile-fact-icon">{{ fact.icon }}</span>
                            <span class="profile-fact-text">{{ fact.label }}</span>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="hasLanguages" :style="getSectionOrderStyle('languages')">
                <div class="content languages-section">
                    <span>Языки</span>
                    <div class="language-badges">
                        <span v-for="language in selectedLanguages" :key="language.code" class="language-badge">{{ getLanguageLabel(language) }}</span>
                    </div>
                </div>
            </section>
            <section v-if="cardData.socials && cardData.socials.length > 0" :style="getSectionOrderStyle('socials')">
                <div class="content">
                    <span>Социальные сети</span>
                    <div class="social-wrapper">
                        <SocialIcon  target="_blank"  v-for="(social, index) in cardData.socials" :type="social.type" :key="index" :href="social.link"></SocialIcon>
                        
                    </div>
                </div>
                
            </section>
            <section v-if="hasContacts" :style="getSectionOrderStyle('contacts')">
                <div class="content">
                    <span>Контакты</span>
                    <div class="contact-wrapper">
                        <div class="contact" v-for="(email, index) in cardData.emails" :key="index">
                            <div class="contact-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <rect width="20" height="16" x="2" y="4" rx="2"/>
                                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                                </svg>
                            </div>
                            <div class="contact-info">
                                <a :href="`mailto:${email.link}`" target="_blank" class="contact-link">{{ email.email }}</a>
                                <span class="type">{{ types[`${email.type}_email`] }}</span>
                            </div>
                        </div>
                        <div class="contact" v-for="(phone, index) in cardData.phones" :key="index">
                            <div class="contact-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                                </svg>
                            </div>
                            <div class="contact-info">
                                <a :href="`tel:${normalizePhoneForPayload(phone.phone) || phone.phone}`" target="_blank" class="contact-link">{{ formatPhoneDisplay(phone.phone) }}</a>
                                <span class="type">{{ types[`${phone.type}`] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="cardData.jobs && cardData.jobs.length > 0" :style="getSectionOrderStyle('jobs')">
                <div class="content">
                    <span>Работа</span>
                    <div class="jobs-wrapper">
                        <div class="job" v-for="(job, index) in cardData.jobs" :key="index">
                            <div class="job_info">
                                <div class="job_header">
                                    <span class="job_name">{{ job.company }}</span>
                                    <div class="job_badge" :class="{ 'job_badge--current': !job.endDate }">
                                        {{ !job.endDate ? 'Текущее место' : 'Предыдущее место' }}
                                    </div>
                                </div>
                                <span class="job_position">{{ job.position }}</span>
                                <div class="job_time">
                                    <div class="job_time__element">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <polyline points="12 6 12 12 16 14"></polyline>
                                        </svg>
                                        {{ job.startDate }}
                                    </div>
                                    <div class="job_time__element">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M5 12h14"></path>
                                            <path d="M12 5l7 7-7 7"></path>
                                        </svg>
                                        {{ job.endDate ? job.endDate : "настоящее время" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="cardData.websites && cardData.websites.length > 0" :style="getSectionOrderStyle('websites')">
                <div class="content">
                    <span>Сайты</span>
                    <div class="site-wrapper">
                        <a class="social" :href="site.url" target="_blank" v-for="(site, index) in cardData.websites" :key="index" >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_5339_698)">
                                <path d="M5.5 8C5.5 8.63333 5.52833 9.24733 5.581 9.83333H10.419C10.4717 9.24733 10.5 8.63333 10.5 8C10.5 7.36667 10.4717 6.75267 10.4187 6.16667H5.58167C5.52833 6.75267 5.5 7.36667 5.5 8ZM4.57767 6.16667C4.5255 6.77638 4.49958 7.38806 4.5 8C4.5 8.62867 4.52667 9.24233 4.57733 9.83333H0.725667C0.578333 9.24667 0.5 8.63233 0.5 8C0.5 7.36767 0.578333 6.75333 0.725667 6.16667H4.57767ZM5.69967 5.16667H10.3C10.152 4.15767 9.928 3.258 9.65033 2.519C9.39067 1.828 9.094 1.303 8.79033 0.960333C8.486 0.616333 8.21733 0.5 8 0.5C7.78267 0.5 7.514 0.616667 7.20933 0.96C6.90567 1.30333 6.609 1.828 6.34933 2.519C6.07167 3.258 5.84767 4.15767 5.69933 5.16667M11.4223 6.16667C11.4733 6.75767 11.5 7.37133 11.5 8C11.5 8.62867 11.4733 9.24233 11.4227 9.83333H15.2743C15.4217 9.24667 15.5 8.63233 15.5 8C15.5 7.36767 15.4217 6.75333 15.2743 6.16667H11.4223ZM14.9467 5.16667H11.3103C11.1537 4.03733 10.9057 3.01667 10.5867 2.16733C10.383 1.62533 10.1457 1.14 9.87533 0.736333C12.182 1.33033 14.0587 2.994 14.946 5.16667M4.68933 5.16667H1.05367C1.94067 2.994 3.81767 1.33033 6.12433 0.736667C5.85433 1.14 5.61667 1.62533 5.413 2.16733C5.094 3.01667 4.84633 4.03733 4.68967 5.16667M4.68867 10.8333H1.05367C1.94033 13.005 3.81567 14.668 6.12033 15.2627C5.85033 14.8593 5.61367 14.374 5.41033 13.8327C5.092 12.9827 4.84467 11.9627 4.68867 10.8333ZM9.65333 13.4813C9.93 12.7423 10.1533 11.8427 10.3013 10.8333H5.69867C5.84633 11.8427 6.06967 12.7423 6.34667 13.4813C6.606 14.1723 6.90233 14.697 7.20667 15.0397C7.51067 15.383 7.78 15.5 8 15.5C8.22 15.5 8.48933 15.383 8.79333 15.0397C9.09767 14.697 9.394 14.1723 9.65333 13.4813ZM10.5897 13.8323C10.908 12.983 11.1553 11.9623 11.3113 10.8333H14.9463C14.0597 13.005 12.1843 14.668 9.87967 15.2627C10.1497 14.8593 10.3863 14.3737 10.5897 13.8323Z" fill="#ACE715"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_5339_698">
                                <rect width="16" height="16" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>

                        </a>
                        
                    </div>
                </div>
            </section>
            <section v-if="cardData.education && cardData.education.length > 0" :style="getSectionOrderStyle('education')">
                <div class="content">
                    <span>Образование</span>
                    <div class="jobs-wrapper">
                        <div class="job" v-for="(item, index) in cardData.education" :key="index">
                            <div class="job_info">
                                <span class="job_name">{{ item.school }}</span>
                                <span class="job_position">{{ item.degree }}</span>
                                <div v-if="item.startYear || item.endYear" class="job_time">
                                    <div class="job_time__element">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <polyline points="12 6 12 12 16 14"></polyline>
                                        </svg>
                                        {{ item.startYear }}
                                    </div>
                                    <div class="job_time__element">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M5 12h14"></path>
                                            <path d="M12 5l7 7-7 7"></path>
                                        </svg>
                                        {{ item.endYear || "настоящее время" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </div>
            <span class="copyright">© {{new Date().getFullYear() }} EWERT </span>
        </div>
        <div class="actions" v-if="cardData != {} && cardData != undefined && cardData != null && !failed">
            <EWButton @click="shareContact">Поделиться контактом</EWButton>
            <EWButton variant="secondary" @click="getContact()">Сохранить контакт</EWButton>
        </div>
    </div>
    </Transition>
    
    <!-- Share Contact Modal -->
    <div v-if="showShareModal" class="modal-overlay" @click="closeShareModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Поделиться контактом</h3>
          <button class="modal-close" @click="closeShareModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        
        <form @submit.prevent="submitShareContact" class="share-form">
          <div class="form-group">
            <label class="form-label">Как к вам обращаться?</label>
            <input 
              v-model="shareForm.name" 
              type="text" 
              class="form-input" 
              placeholder="Ваше имя"
              required
            />
          </div>
          
          <div class="form-group">
            <label class="form-label">Номер телефона</label>
            <input 
              :value="formatPhoneForInput(shareForm.phone)"
              type="tel" 
              inputmode="tel"
              maxlength="18"
              class="form-input" 
              placeholder="+7 (___) ___-__-__"
              @input="onSharePhoneInput($event.target.value)"
              required
            />
          </div>
          
          <div class="form-group">
            <label class="checkbox-label">
              <input 
                v-model="shareForm.consent" 
                type="checkbox" 
                class="checkbox-input"
                required
              />
              <span class="checkbox-custom"></span>
              <span class="checkbox-text">
                Я согласен на <a href="https://ewertcards.com/privacy" style="text-decoration: underline;" target="_blank">обработку персональных данных</a>
              </span>
            </label>
          </div>
          
          <div class="form-actions">
            <button type="button" class="btn-secondary" @click="closeShareModal">
              Отмена
            </button>
            <button 
              type="submit" 
              class="btn-primary" 
              :disabled="!shareForm.consent || submittingShare"
            >
              {{ submittingShare ? 'Отправка...' : 'Отправить' }}
            </button>
          </div>
        </form>
        
        <div v-if="shareError" class="error-message">
          {{ shareError }}
        </div>
      </div>
    </div>
</template>

<script>
import EWButton from '@/components/EWButton.vue';
import LoadingState from '@/components/LoadingState.vue';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {Physics2DPlugin} from "gsap/Physics2DPlugin";
import SocialIcon from '@/components/SocialIcon.vue';
import {
    buildActivateUrl,
    buildPublicCardUrl,
    fetchStaticCardData,
    getStaticCardContactUrl
} from '@/lib/cardGateway';
import { formatRussianPhone, normalizeRussianPhone } from '@/utils/phoneUtils';
gsap.registerPlugin(ScrollTrigger, Physics2DPlugin);

const defaultSectionOrder = ['about', 'personal', 'languages', 'socials', 'contacts', 'jobs', 'websites', 'education'];

const relationshipOptions = [
    { value: 'married_male', label: 'Женат', icon: '💍' },
    { value: 'single_male', label: 'Не женат', icon: '🕊️' },
    { value: 'married_female', label: 'Замужем', icon: '💍' },
    { value: 'in_love', label: 'Влюблен', icon: '💚' },
    { value: 'complicated', label: 'Все сложно', icon: '🌀' }
];

const languageOptions = [
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'ko', name: '한국어', flag: '🇰🇷' },
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'ar', name: 'العربية', flag: '🇦🇪' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' }
];

export default {
    name: 'CardView',
    components: {
        LoadingState,
        EWButton, SocialIcon
    },
    data() {
        return {
            cardId: null,
            hintActive : false,
            hintTimeout : null,
            failed: false,
            failedMessage: 'Произошла ошибка, такой карты не существует',
            menuExpanded: false,
            types : {
                "personal": "Личный",
                "personal_email" : "Личная",
                "work": "Рабочий",
                "work_email": "Рабочая",
            },
            loading: true,
            cardData: {},
            cardSource: 'static',
            redirecting: false,
            loadCompleteTimeout: null,
            showShareModal: false,
            submittingShare: false,
            viewTrackingTimeout: null,
            shareError: '',
            scrollLockActive: false,
            shareForm: {
                name: '',
                phone: '',
                consent: false
            }
        };
    },
    computed: {
        cardPublicId() {
            return this.cardData.customId || this.cardId || this.cardData._id || '';
        },
        cardAvatarUrl() {
            if (this.cardSource === 'api' && this.cardData.avatar) {

                return this.getAvatarUrl(this.cardData.avatar);

            }

            if (this.cardPublicId) {
                return this.cardData.avatar;
            }


            console.log(this.cardData.avatar);
            
            return this.cardData.avatar ? this.getAvatarUrl(this.cardData.avatar) : 'https://storage.yandexcloud.net/card.ewertcards.com/avatar.svg';
        },
        cardCanonicalUrl() {
            return this.cardPublicId ? buildPublicCardUrl(this.cardPublicId) : window.location.href;
        },
        cardContactUrl() {
            return this.cardPublicId ? getStaticCardContactUrl(this.cardPublicId) : '';
        },
        cardSectionOrder() {
            return this.normalizeSectionOrder(this.cardData.sectionOrder);
        },
        hasContacts() {
            return (Array.isArray(this.cardData.emails) && this.cardData.emails.length > 0)
                || (Array.isArray(this.cardData.phones) && this.cardData.phones.length > 0);
        },
        selectedLanguages() {
            const languages = Array.isArray(this.cardData.languages) ? this.cardData.languages : [];
            return languageOptions.filter(language => languages.includes(language.code));
        },
        hasPersonalDetails() {
            return Boolean(this.cardData.birthday || this.cardData.relationshipStatus);
        },
        hasLanguages() {
            return this.selectedLanguages.length > 0;
        },
        profileFacts() {
            const facts = [];
            const age = this.getAge(this.cardData.birthday);
            if (age) facts.push({ key: 'birthday', icon: '🎂', label: `${age} ${this.getAgeWord(age)}` });

            const relationship = this.getRelationshipOption(this.cardData.relationshipStatus);
            if (relationship) facts.push({ key: 'relationship', icon: relationship.icon, label: relationship.label });
            return facts;
        },
        canShareCard() {
            return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
        }
    },
    methods: {
        normalizeSectionOrder(sectionOrder) {
            if (!Array.isArray(sectionOrder)) {
                return [...defaultSectionOrder];
            }

            const allowed = new Set(defaultSectionOrder);
            const normalized = sectionOrder.filter(section => allowed.has(section));
            defaultSectionOrder.forEach(section => {
                if (!normalized.includes(section)) {
                    normalized.push(section);
                }
            });
            return normalized;
        },
        getSectionOrderStyle(section) {
            const index = this.cardSectionOrder.indexOf(section);
            return { order: index === -1 ? defaultSectionOrder.length : index + 1 };
        },
        getRelationshipOption(value) {
            return relationshipOptions.find(status => status.value === value) || null;
        },
        getLanguageLabel(language) {
            return `${language.flag} ${language.name}`;
        },
        getAge(birthday) {
            if (!birthday) return null;
            const birthDate = new Date(`${birthday}T00:00:00`);
            if (Number.isNaN(birthDate.getTime())) return null;

            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDelta = today.getMonth() - birthDate.getMonth();
            if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < birthDate.getDate())) {
                age -= 1;
            }
            return age > 0 && age < 130 ? age : null;
        },
        getAgeWord(age) {
            const mod10 = age % 10;
            const mod100 = age % 100;
            if (mod10 === 1 && mod100 !== 11) return 'год';
            if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'года';
            return 'лет';
        },
        applyCardData(card, source = 'api') {
            const resolvedId = card?.customId || card?._id || this.cardId;
            this.cardData = {
                ...card,
                customId: resolvedId
            };
            this.cardSource = source;
            this.updateMetaTags();
            this.scheduleViewTracking();
        },
        scheduleViewTracking() {
            clearTimeout(this.viewTrackingTimeout);

            const trackedCardId = String(this.cardId || this.cardPublicId || '').trim();
            if (!trackedCardId || this.failed || this.redirecting) {
                return;
            }

            this.viewTrackingTimeout = setTimeout(() => {
                this.$viewTracker?.trackCardView(trackedCardId);
                this.viewTrackingTimeout = null;
            }, 1000);
        },
        finishCardLoad() {
            if (this.redirecting) {
                return;
            }

            const delay = this.failed ? 0 : 1000;
            clearTimeout(this.loadCompleteTimeout);
            this.loadCompleteTimeout = setTimeout(() => {
                this.loading = false;
                this.loadCompleteTimeout = null;

                if (this.failed) {
                    return;
                }

                this.$nextTick(() => {
                    this.setupAnimations();
                });
            }, delay);
        },
        async checkActivationAndMaybeRedirect(){
            try{
                const id = this.$route.params.id
                const res = await this.$api.get(`api/cards/${id}/status`)
                if(res?.error){
                    if (this.isCardNotFound(res)) {
                        this.failedMessage = 'Карточка недоступна'
                    }
                    // not found
                    this.failed = true
                    return false
                }
                if (!res.activated){
                    this.redirecting = true
                    window.location.assign(buildActivateUrl(id))
                    return false
                }
                return true
            }catch(e){
                // If status endpoint fails, fall back to existing flow
                return true
            }
        },
        stopListenHint(){
            clearTimeout(this.hintTimeout);
        },
        async getCardInfo() {
            try {
                const staticCard = await fetchStaticCardData(this.cardId)
                if (staticCard) {
                    this.applyCardData(staticCard, 'static')
                    return
                }

                const canContinue = await this.checkActivationAndMaybeRedirect()
                if (!canContinue) {
                    return
                }

                const request = await this.$api.get(`card/${this.cardId}`);
                if (request?.error || !request?.card) {
                    if (this.isCardNotFound(request)) {
                        this.failedMessage = 'Карточка недоступна';
                    }
                    this.failed = true;
                } else {
                    this.applyCardData(request.card, 'api');
                }
            } catch (error) {
                if (this.isCardNotFound(error?.response?.data)) {
                    this.failedMessage = 'Карточка недоступна';
                }
                this.failed = true;
            } finally {
                this.finishCardLoad();
            }
        },
        async scrollHint(){
            if(document.querySelector('.scrollable').scrollHeight < 900) return;
            this.hintActive = true;
            
            await this.$nextTick();
            gsap.to(this.$refs.hint,{
                y: 10,
                duration: 0.5,
                ease: "bounce",
                onComplete: ()=>{
                     gsap.to(this.$refs.hint,{
                        y: 0,
                        duration: 0.5,
                        ease: "bounce"
                    })
                }
            })
           
            document.querySelector(".scrollable").scrollTo({ top: 50, behavior: 'smooth' });
            setTimeout(()=>{
            document.querySelector(".scrollable").scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
            this.hintActive = false;    
            }, 800);
            
            },400)
        },
        async getContact() {
            try {
                const cardId = this.cardPublicId || this.cardId;
                const contactUrl = this.cardContactUrl || `/card/${encodeURIComponent(cardId)}/contact`;
                window.location.href = contactUrl;
            } catch (error) {
                alert('Не удалось сохранить контакт')
            }
        },

        shareContact() {
            this.showShareModal = true;
            this.shareError = '';
            // Reset form
            this.shareForm = {
                name: '',
                phone: '',
                consent: false
            };
        },

        closeShareModal() {
            this.showShareModal = false;
            this.shareError = '';
        },

        async submitShareContact() {
            this.submittingShare = true;
            this.shareError = '';

            try {
                const response = await this.$api.post(`api/cards/${this.cardData._id || this.cardData.customId}/share-contact`, {
                    name: this.shareForm.name,
                    phone: this.normalizePhoneForPayload(this.shareForm.phone),
                    cardId: this.cardData._id || this.cardData.customId
                });

                if (response.error) {
                    if (this.isCardNotFound(response)) {
                        this.closeShareModal();
                        this.failed = true;
                        this.failedMessage = 'Карточка недоступна';
                        return;
                    }
                    this.shareError = response.error;
                } else {
                    // Success
                    this.closeShareModal();
                    // Show success message
                    alert('Ваш контакт отправлен владельцу карты!');
                }
            } catch (error) {
                this.shareError = 'Произошла ошибка при отправке контакта';
            } finally {
                this.submittingShare = false;
            }
        },
        formatPhoneForInput(value) {
            return formatRussianPhone(value);
        },
        formatPhoneDisplay(value) {
            return formatRussianPhone(value) || value || '';
        },
        normalizePhoneForPayload(value) {
            return normalizeRussianPhone(value);
        },
        isCardNotFound(response) {
            return response?.code === 'CARD_NOT_FOUND'
                || response?.errorCode === 'CARD_NOT_FOUND'
                || response?.error === 'CARD_NOT_FOUND';
        },
        isCardNotFoundResponseText(value) {
            if (typeof value !== 'string') return false;
            try {
                return this.isCardNotFound(JSON.parse(value));
            } catch (error) {
                return false;
            }
        },
        onSharePhoneInput(value) {
            this.shareForm.phone = this.formatPhoneForInput(value);
        },
        
        // Update meta tags for social media sharing
        updateMetaTags() {
            if (!this.cardData) return;
            
            const fullName = `${this.cardData.firstName || ''} ${this.cardData.lastName || ''}`.trim();
            const bio = this.cardData.bio || this.cardData.description || 'Цифровая визитная карточка';
            const cardUrl = this.cardCanonicalUrl;
            const avatarUrl = this.cardAvatarUrl || null;
            
            // Update page title
            document.title = fullName ? `${fullName} - EWERT Cards` : 'EWERT Cards';
            
            // Helper function to update or create meta tag
            const updateMetaTag = (property, content, isProperty = false) => {
                if (!content) return;
                
                const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
                let meta = document.querySelector(selector);
                
                if (!meta) {
                    meta = document.createElement('meta');
                    if (isProperty) {
                        meta.setAttribute('property', property);
                    } else {
                        meta.setAttribute('name', property);
                    }
                    document.head.appendChild(meta);
                }
                
                meta.setAttribute('content', content);
            };
            
            // Basic meta tags
            updateMetaTag('description', bio);
            
            // Open Graph meta tags for Facebook, LinkedIn, etc.
            updateMetaTag('og:title', fullName || 'EWERT Cards', true);
            updateMetaTag('og:description', bio, true);
            updateMetaTag('og:url', cardUrl, true);
            updateMetaTag('og:type', 'profile', true);
            updateMetaTag('og:site_name', 'EWERT Cards', true);
            
            if (avatarUrl) {
                updateMetaTag('og:image', avatarUrl, true);
                updateMetaTag('og:image:alt', `Фото ${fullName}`, true);
                updateMetaTag('og:image:width', '400', true);
                updateMetaTag('og:image:height', '400', true);
            }
            
            // Twitter Card meta tags
            updateMetaTag('twitter:card', 'summary_large_image');
            updateMetaTag('twitter:site', '@ewertcards');
            updateMetaTag('twitter:creator', '@ewertcards');
            updateMetaTag('twitter:title', fullName || 'EWERT Cards');
            updateMetaTag('twitter:description', bio);
            
            if (avatarUrl) {
                updateMetaTag('twitter:image', avatarUrl);
                updateMetaTag('twitter:image:alt', `Фото ${fullName}`);
            }
            
            // Additional profile-specific meta tags
            if (this.cardData.phones && this.cardData.phones.length > 0) {
                updateMetaTag('profile:contact_data:phone_number', this.normalizePhoneForPayload(this.cardData.phones[0].phone), true);
            }
            
            if (this.cardData.emails && this.cardData.emails.length > 0) {
                updateMetaTag('profile:contact_data:email', this.cardData.emails[0].email, true);
            }
            
            // Professional info
            if (this.cardData.jobs && this.cardData.jobs.length > 0) {
                const currentJob = this.cardData.jobs.find(job => !job.endDate) || this.cardData.jobs[0];
                if (currentJob) {
                    updateMetaTag('profile:job_title', currentJob.position, true);
                    updateMetaTag('profile:organization', currentJob.company, true);
                }
            }
            
            // VCard link
            const vcardUrl = this.cardContactUrl;
            updateMetaTag('profile:contact_data:url', vcardUrl, true);
            
            console.log('[CARD] Meta tags updated for social sharing:', {
                title: fullName,
                description: bio,
                image: avatarUrl,
                url: cardUrl
            });
            
            // Also add structured data
            this.addStructuredData();
        },
        
        // Clean up meta tags when leaving the page
        cleanupMetaTags() {
            // Reset page title
            document.title = 'EWERT Cards';
            
            // Remove dynamic meta tags (keep only the default ones)
            const metaTagsToRemove = [
                'og:title', 'og:description', 'og:url', 'og:type', 'og:image',
                'og:image:alt', 'og:image:width', 'og:image:height',
                'twitter:title', 'twitter:description', 'twitter:image', 'twitter:image:alt',
                'profile:contact_data:phone_number', 'profile:contact_data:email',
                'profile:job_title', 'profile:organization', 'profile:contact_data:url'
            ];
            
            metaTagsToRemove.forEach(tagName => {
                const propertyMeta = document.querySelector(`meta[property="${tagName}"]`);
                const nameMeta = document.querySelector(`meta[name="${tagName}"]`);
                
                if (propertyMeta) {
                    propertyMeta.remove();
                }
                if (nameMeta) {
                    nameMeta.remove();
                }
            });
            
            // Reset description to default
            const descMeta = document.querySelector('meta[name="description"]');
            if (descMeta) {
                descMeta.setAttribute('content', 'Цифровые визитные карточки нового поколения');
            }
            
            // Remove structured data
            const structuredDataScript = document.querySelector('script[type="application/ld+json"][data-card-schema]');
            if (structuredDataScript) {
                structuredDataScript.remove();
            }
            
            console.log('[CARD] Meta tags cleaned up');
        },
        
        // Add structured data (JSON-LD) for better SEO
        addStructuredData() {
            if (!this.cardData) return;
            
            const fullName = `${this.cardData.firstName || ''} ${this.cardData.lastName || ''}`.trim();
            const avatarUrl = this.cardAvatarUrl || null;
            const cardUrl = this.cardCanonicalUrl;
            
            // Create JSON-LD structured data
            const structuredData = {
                "@context": "https://schema.org",
                "@type": "Person",
                "name": fullName,
                "description": this.cardData.bio || this.cardData.description,
                "url": cardUrl
            };
            
            if (avatarUrl) {
                structuredData.image = avatarUrl;
            }
            
            // Add contact information
            if (this.cardData.emails && this.cardData.emails.length > 0) {
                structuredData.email = this.cardData.emails[0].email;
            }
            
            if (this.cardData.phones && this.cardData.phones.length > 0) {
                structuredData.telephone = this.normalizePhoneForPayload(this.cardData.phones[0].phone);
            }
            
            // Add job information
            if (this.cardData.jobs && this.cardData.jobs.length > 0) {
                const currentJob = this.cardData.jobs.find(job => !job.endDate) || this.cardData.jobs[0];
                if (currentJob) {
                    structuredData.jobTitle = currentJob.position;
                    structuredData.worksFor = {
                        "@type": "Organization",
                        "name": currentJob.company
                    };
                }
            }
            
            // Add social media profiles
            if (this.cardData.socials && this.cardData.socials.length > 0) {
                structuredData.sameAs = this.cardData.socials.map(social => social.link).filter(link => link);
            }
            
            // Remove existing structured data
            const existingScript = document.querySelector('script[type="application/ld+json"][data-card-schema]');
            if (existingScript) {
                existingScript.remove();
            }
            
            // Add new structured data
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.setAttribute('data-card-schema', 'true');
            script.textContent = JSON.stringify(structuredData, null, 2);
            document.head.appendChild(script);
            
            console.log('[CARD] Structured data added:', structuredData);
        },
        setupAnimations() {
            const sections = document.querySelectorAll('section');
            const scrollable = document.querySelector('.scrollable');
            
            // Анимация для контактов
            const contacts = document.querySelectorAll('.contact');
            contacts.forEach((contact, index) => {
                gsap.fromTo(contact,
                    {
                        x: -50,
                        opacity: 0,
                        scale: 0.8
                    },
                    {
                        x: 0,
                        opacity: 1,
                        scale: 1,
                        duration: 0.8,
                        delay: index * 0.1,
                        ease: 'back.out(1.7)',
                        scrollTrigger: {
                            trigger: contact,
                            scroller: scrollable,
                            start: 'top 85%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            });

            // Анимация для работы
            const jobs = document.querySelectorAll('.job');
            jobs.forEach((job, index) => {
                gsap.fromTo(job,
                    {
                        y: 30,
                        opacity: 0
                    },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.6,
                        delay: index * 0.1,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: job,
                            scroller: scrollable,
                            start: 'top 85%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            });

            // Анимация для социальных сетей
            const socials = document.querySelectorAll('.social');
            socials.forEach((social, index) => {
                gsap.fromTo(social,
                    {
                        x: 50,
                        opacity: 0,
                        scale: 0.8
                    },
                    {
                        x: 0,
                        opacity: 1,
                        scale: 1,
                        duration: 0.6,
                        delay: index * 0.1,
                        ease: 'back.out(1.7)',
                        scrollTrigger: {
                            trigger: social,
                            scroller: scrollable,
                            start: 'top 85%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            });

            // Анимация для текста aboutme
            const aboutmeText = document.querySelector('.aboutme p');
            if (aboutmeText) {
                gsap.fromTo(aboutmeText,
                    {
                        y: 20,
                        opacity: 0,
                        filter: 'blur(10px)'
                    },
                    {
                        y: 0,
                        opacity: 1,
                        filter: 'blur(0px)',
                        duration: 1,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: aboutmeText,
                            scroller: scrollable,
                            start: 'top 85%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            }

            // Анимация для остальных секций
            sections.forEach((section, index) => {
                const isLastSection = index === sections.length - 1;
                gsap.fromTo(section,
                    {
                        y: 20,
                        opacity: 0.5,
                        '--gradient-layer-opacity': '1',
                        '--gradient-angle': '0deg'
                    },
                    {
                        y: 0,
                        opacity: 1,
                        '--gradient-angle': '212deg',
                        '--gradient-layer-opacity': '0.4',
                        duration: 1,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: section,
                            scroller: scrollable,
                            start: isLastSection ? 'top 90%' : 'top 90%',
                            end: isLastSection ? 'top 40%' : 'top 30%',
                            scrub: true,
                            toggleActions: 'play none none none',
                            markers: false
                        }
                    }
                );
            });
            this.pageLoaded();
        },
        pageLoaded(){
            this.hintTimeout = setTimeout(() => {
                
                
                if(document.querySelector('.scrollable').scrollTop == 0){
                    this.scrollHint();
                }
            }, 4000);
        },
        menu() {
            this.menuExpanded ? this.closeMenu() : this.openMenu();
        },
        openMenu() {
            this.menuExpanded = true;
            const scrollable = this.$refs.scrollable;
            if (!scrollable) {
                return;
            }

            if (!this.scrollLockActive) {
                scrollable.dataset.prevOverflowY = scrollable.style.overflowY || '';
                scrollable.style.overflowY = 'hidden';
                this.scrollLockActive = true;
            }
        },
        closeMenu() {
            this.menuExpanded = false;
            const scrollable = this.$refs.scrollable;
            if (scrollable && this.scrollLockActive) {
                scrollable.style.overflowY = scrollable.dataset.prevOverflowY || '';
                delete scrollable.dataset.prevOverflowY;
                this.scrollLockActive = false;
            }
        },
        async shareCardPage() {
            if (!this.canShareCard) return;

            try {
                await navigator.share({
                    title: this.cardData.name || this.cardData.title || 'EWERT Cards',
                    text: this.cardData.description || 'Цифровая визитка',
                    url: this.cardCanonicalUrl
                });
                this.closeMenu();
            } catch (error) {
                if (error?.name !== 'AbortError') {
                    console.warn('Failed to share card page:', error);
                }
            }
        },
        confetti(event){
            if(event.target.tagName != 'BUTTON' && event.target.tagName != 'A' && event.target.tagName != 'section') return;
            const dotCount = gsap.utils.random(15, 30, 1);
            const colors = ["#0ae448", "#abff84", "#fffce1"]; // Define colors once

            for (let i = 0; i < dotCount; i++) {
              // Create a dot element
              const dot = document.createElement("div");
              dot.classList.add("dot");

              // Append the dot to the card container instead of body
              document.querySelector('.card').appendChild(dot);

              // Set initial position and styles of the dot
              gsap.set(dot, {
                backgroundColor: gsap.utils.random(colors), // Pick a random color
                top: event.clientY, // position dot at coordinates of the click
                left: event.clientX,
                scale: 0 // Start at scale 0
              });

              // Animate the dot with physics2D
              gsap
                .timeline({
                  onComplete: () => dot.remove() // Remove the dot after animation
                })
                .to(dot, {
                  scale: gsap.utils.random(0.3, 1), // Scale between 0.5 and 1
                  duration: 0.3, // Quick pop-in effect
                  ease: "power3.out"
                })
                .to(
                  dot,
                  {
                    duration: 2,
                    physics2D: {
                      velocity: gsap.utils.random(500, 1000), // Random velocity
                      angle: gsap.utils.random(0, 360), // Random direction
                      gravity: 1500 // Gravity effect
                    },
                    autoAlpha: 0, // Fade out towards the end
                    ease: "none"
                  },
                  "<"
                ); }
        },
    },
    watch: {
        '$route.params.id': {
            async handler(newId, oldId) {
                if (!newId || newId === oldId) {
                    return;
                }

                this.cardId = newId;
                this.failed = false;
                this.failedMessage = 'Произошла ошибка, такой карты не существует';
                this.loading = true;
                this.cardData = {};
                this.cardSource = 'static';
                this.redirecting = false;
                clearTimeout(this.viewTrackingTimeout);
                this.viewTrackingTimeout = null;
                clearTimeout(this.loadCompleteTimeout);
                this.loadCompleteTimeout = null;
                this.cleanupMetaTags();
                ScrollTrigger.getAll().forEach(trigger => {
                    if (trigger.trigger && this.$el?.contains(trigger.trigger)) {
                        trigger.kill();
                    }
                });
                await this.getCardInfo();
            }
        }
    },
    async mounted() {
        this.cardId = this.$route.params.id;
        await this.getCardInfo();
        document.addEventListener('click', this.confetti);
    },
    beforeUnmount() {
        // Очистка всех ScrollTrigger'ов, связанных с компонентом
        clearTimeout(this.viewTrackingTimeout);
        clearTimeout(this.loadCompleteTimeout);
        const scrollable = this.$refs.scrollable;
        if (scrollable && this.scrollLockActive) {
            scrollable.style.overflowY = scrollable.dataset.prevOverflowY || '';
            delete scrollable.dataset.prevOverflowY;
            this.scrollLockActive = false;
        }
        ScrollTrigger.getAll().forEach(trigger => {
            if (trigger.trigger && this.$el.contains(trigger.trigger)) {
                trigger.kill();
            }
        });
        
        // Clean up meta tags when leaving the page
        this.cleanupMetaTags();
        
        // Remove event listeners
        document.removeEventListener('click', this.confetti);
    },
    created(){
        // Добавляем обработчик клика для конфетти
        
    }
}
</script>

<style scoped>
.not-found {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    min-height: 100svh;
    padding: 32px 18px calc(28px + env(safe-area-inset-bottom));
    background: light-dark(#f2f2f7, #000);
    color: light-dark(#111, #fff);
}

.not-found::before {
    content: "";
    width: 1px;
    height: 32px;
}

.not-found-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.broken-card {
    scale: 0.9;
    position: relative;
    width: min(72vw, 320px);
    aspect-ratio: 543 / 929;
    margin-bottom: 22px;
}

.broken-card-part {
    position: absolute;
    width: 100%;
    height: auto;
    object-fit: contain;
    transform-origin: center;
    will-change: transform;
}

.broken-card-part--top {
    top: 0;
    left: 0;
    animation: break-card-top 1.1s cubic-bezier(0.22, 1, 0.36, 1) 1.8s both;
}

.broken-card-part--bottom {
    top: 50%;
    left: 0;
    animation: break-card-bottom 1.1s cubic-bezier(0.22, 1, 0.36, 1) 1.8s both;
}

@keyframes break-card-top {
    0% {
        transform: translate3d(0, 56px, 0) rotate(0deg);
    }
    100% {
        transform: translate3d(-35px, 20px, 0) rotate(-7deg);
    }
}

@keyframes break-card-bottom {
    0% {
        transform: translate3d(0, 0, 0) rotate(0deg);
    }
    100% {
        transform: translate3d(30px, 25px, 0) rotate(6deg);
    }
}

.not-found p {
    margin: 0;
    color: light-dark(#111, #fff);
    font-size: 20px;
    font-weight: 500;
    line-height: 1.3;
    text-align: center;
}

.not-found-link {
    color: light-dark(#666, #aaa);
    font-size: 14px;
    text-decoration: none;
    border-bottom: 1px solid currentColor;
}
.card {
    display: flex;
    flex-direction: column;
    height: 100svh;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
}
.scrollable {
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
    padding: 20px 10px;
    padding-top: 0;
    padding-bottom: 140px; /* Добавляем отступ снизу для кнопок */
    flex: 1;
}
.ordered-sections {
    display: flex;
    flex-direction: column;
}
.actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    padding: 10px 21px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px) invert(0.1);
    z-index: 5;
}
h1 {
    font-weight: 400;
    font-size: 18px;
}

.name-emoji {
    margin-left: 6px;
    font-size: 20px;
    line-height: 1;
}

.avatar {
    height: 130px;
    width: 130px;
    border-radius: 50%;
    object-position: center;
    object-fit: cover;
}
.header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}
.bio {
    color: #777777;
    font-size: 14px;
    font-weight: 300;
}
section {
    margin: 20px auto; /* Отступы между секциями */
    width: 100%;

}
section .content {
    border-radius: 10px;
    padding: 15px;
    background: light-dark(rgba(255, 255, 255, 0.95), #030306);
    box-shadow: light-dark(0 2px 8px rgba(0, 0, 0, 0.05), 0 2px 8px rgba(0, 0, 0, 0.2));
}

section p {
    margin: 0;
    color: light-dark(#333,#ccc);
}

.personal-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.languages-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.profile-facts {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(126px, 1fr));
    gap: 10px;
    margin-top: 2px;
}

.profile-fact {
    min-height: 54px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 12px;
    border: 1px solid light-dark(rgba(0, 0, 0, 0.08), rgba(255, 255, 255, 0.1));
    border-radius: 12px;
    background: light-dark(rgba(255, 255, 255, 0.9), rgba(26, 26, 26, 0.5));
    color: light-dark(#111, #fff);
}

.profile-fact-icon {
    width: 32px;
    height: 32px;
    display: inline-flex !important;
    margin-bottom: 0 !important;
    align-items: center;
    justify-content: center;
    flex: 0 0 32px;
    border-radius: 10px;
    background: light-dark(rgba(172, 231, 21, 0.12), rgba(172, 231, 21, 0.08));
    font-size: 18px;
}

.profile-fact-text {
    min-width: 0;
    overflow: hidden;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.language-badges {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.language-badge {
    height: 44px;
    display: inline-flex !important;
    margin-bottom: 0 !important;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 14px;
    border: 1px solid light-dark(rgba(0, 0, 0, 0.08), rgba(255, 255, 255, 0.1));
    border-radius: 12px;
    background: light-dark(rgba(255, 255, 255, 0.9), rgba(26, 26, 26, 0.5));
    color: light-dark(#111, #fff);
    font-family: 'Bounded';
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;
}

.site-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    flex-wrap: wrap;
    margin-top: 10px;
}

.site-wrapper .social {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background-color: light-dark(rgba(12, 11, 11, 0.124), rgba(228, 228, 228, 0.124));
    border: 0.5px solid light-dark(rgba(21, 21, 21, 0.1), rgba(255,255,255,0.1));
    transition: transform 0.3s ease;
}

.site-wrapper .social:hover {
    transform: scale(1.1);
}

.site-wrapper .social-icon {
    width: 20px;
    height: 20px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.menu-backdrop {
    position: fixed;
    inset: 0;
    z-index: 30;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: rgba(0, 0, 0, 0.42);
    backdrop-filter: blur(8px);
}

.menu-sheet {
    width: 100%;
    max-width: 460px;
    margin-top: auto;
    background: light-dark(#ffffff, #1c1c1e);
    border: 1px solid light-dark(#e5e5e5, #2a2a2d);
    border-bottom: none;
    border-radius: 18px 18px 0 0;
    box-shadow: 0 -18px 46px rgba(0, 0, 0, 0.28);
    padding: 8px 14px max(14px, env(safe-area-inset-bottom));
}

.menu-sheet-handle {
    width: 38px;
    height: 4px;
    margin: 0 auto 12px;
    border-radius: 999px;
    background: light-dark(#d1d1d6, #3a3a3c);
}

.menu-sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.menu-sheet-title {
    color: light-dark(#111, #fff);
    font-size: 18px;
    font-weight: 600;
    line-height: 1.25;
}

.menu-sheet-subtitle {
    margin-top: 2px;
    color: light-dark(#666, #aaa);
    font-size: 13px;
    line-height: 1.35;
}

.menu-close {
    width: 38px;
    height: 38px;
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    border: none;
    border-radius: 10px;
    background: light-dark(#f2f2f7, #2a2a2d);
    color: light-dark(#111, #fff);
    cursor: pointer;
}

.menu-content {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
    overflow: hidden;
    border: 1px solid light-dark(#e5e5e5, #2a2a2d);
    border-radius: 12px;
}

.menu-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 48px;
    width: 100%;
    padding: 0 14px;
    border: none;
    border-bottom: 0.5px solid light-dark(rgba(60, 60, 67, 0.24), rgba(84, 84, 88, 0.58));
    background: light-dark(#fff, #1c1c1e);
    color: light-dark(#111, #fff);
    text-decoration: none;
    font-family: 'Bounded', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
    text-align: left;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;
}

.menu-link:last-child {
    border-bottom: none;
}

.menu-link svg {
    flex: 0 0 auto;
    color: light-dark(#8e8e93, #8e8e93);
}

.menu-link:hover,
.menu-link:active {
    background: light-dark(#f5f5f5, #242428);
}

.menu-sheet-enter-active,
.menu-sheet-leave-active {
    transition: opacity 0.2s ease;
}

.menu-sheet-enter-active .menu-sheet,
.menu-sheet-leave-active .menu-sheet {
    transition: transform 0.24s ease;
}

.menu-sheet-enter-from,
.menu-sheet-leave-to {
    opacity: 0;
}

.menu-sheet-enter-from .menu-sheet,
.menu-sheet-leave-to .menu-sheet {
    transform: translateY(100%);
}

.jobs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 15px;
}

.job {
    display: flex;
    flex-direction: row;
    gap: 15px;
    padding: 20px;
    border-radius: 15px;
    background-color: light-dark(rgba(255, 255, 255, 0.9), rgba(26, 26, 26, 0.5));
    border: 1px solid light-dark(rgba(0, 0, 0, 0.08), rgba(255, 255, 255, 0.1));
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: light-dark(0 2px 8px rgba(0, 0, 0, 0.05), 0 2px 8px rgba(0, 0, 0, 0.2));
}

.job:hover {
    transform: translateY(-2px);
    box-shadow: light-dark(0 5px 15px rgba(0, 0, 0, 0.08), 0 5px 15px rgba(0, 0, 0, 0.3));
}

.job_info {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 8px;
}

.job_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.job_name {
    font-size: 18px;
    font-weight: 500;
    color: light-dark(#1a1a1a, #fff);
    display: flex;
    align-items: center;
    gap: 10px;
}

.job_badge {
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 20px;
    background-color: light-dark(rgba(172, 231, 21, 0.15), rgba(172, 231, 21, 0.1));
    color: light-dark(#2d3a00, #ace715);
    font-weight: 500;
    white-space: nowrap;
    border: 1px solid light-dark(rgba(172, 231, 21, 0.3), rgba(172, 231, 21, 0.2));
}

.job_badge--current {
    background-color: light-dark(rgba(172, 231, 21, 0.2), rgba(172, 231, 21, 0.2));
}

.job_position {
    font-size: 14px;
    color: light-dark(#444, #aaa);
    font-weight: 400;
}

.job_time {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 5px;
}

.job_time__element {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    color: light-dark(#666, #777);
}

.job_time__element svg {
    color: light-dark(#2d3a00, #ace715);
    opacity: 0.7;
}

@media (max-width: 480px) {
    .job {
        padding: 15px;
    }
    
    .job_header {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    
    .job_time {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
}

.contact-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 15px;
}

.contact {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 15px;
    border-radius: 12px;
    background-color: light-dark(rgba(255, 255, 255, 0.9), rgba(26, 26, 26, 0.5));
    border: 1px solid light-dark(rgba(0, 0, 0, 0.08), rgba(255, 255, 255, 0.1));
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.contact:hover {
    transform: translateX(5px);
    box-shadow: light-dark(0 2px 8px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.3));
}

.contact-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background-color: light-dark(rgba(172, 231, 21, 0.1), rgba(172, 231, 21, 0.05));
    color: light-dark(#2d3a00, #ace715);
}

.contact-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
}

.contact-link {
    color: light-dark(#1a1a1a, #fff);
    text-decoration: none;
    font-size: 16px;
    font-weight: 500;
    transition: color 0.3s ease;
}

.contact-link:hover {
    color: light-dark(#2d3a00, #ace715);
}

.type {
    font-size: 12px;
    color: light-dark(#666, #aaa);
    font-weight: 400;
}

/* Share Contact Modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
}

.modal-content {
    background: light-dark(rgba(255, 255, 255, 0.95), #030306);
    border: 1px solid light-dark(#eee, #222);
    border-radius: 16px;
    padding: 24px;
    width: 100%;
    max-width: 400px;
    box-shadow: light-dark(0 8px 32px rgba(0, 0, 0, 0.1), 0 8px 32px rgba(0, 0, 0, 0.4));
    backdrop-filter: blur(10px);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.modal-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: light-dark(#111, #fff);
}

.modal-close {
    background: none;
    border: none;
    color: light-dark(#666, #aaa);
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
    transition: all 0.2s ease;
}

.modal-close:hover {
    background: light-dark(rgba(0, 0, 0, 0.05), rgba(255, 255, 255, 0.1));
    color: light-dark(#111, #fff);
}

.share-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-label {
    font-size: 14px;
    font-weight: 500;
    color: light-dark(#444, #aaa);
}

.form-input {
    padding: 12px 14px;
    border: 1px solid light-dark(#e5e5e5, #333);
    background: light-dark(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.05));
    color: light-dark(#111, #eee);
    border-radius: 10px;
    outline: none;
    font-size: 14px;
    transition: border-color 0.2s ease;
}

.form-input:focus {
    border-color: light-dark(#ace715, #ace715);
}

.checkbox-label {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.4;
}

.checkbox-input {
    display: none;
}

.checkbox-custom {
    width: 18px;
    height: 18px;
    border: 2px solid light-dark(#e5e5e5, #333);
    border-radius: 4px;
    background: light-dark(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.05));
    position: relative;
    flex-shrink: 0;
    margin-top: 1px;
    transition: all 0.2s ease;
}

.checkbox-input:checked + .checkbox-custom {
    background: light-dark(#ace715, #ace715);
    border-color: light-dark(#ace715, #ace715);
}

.checkbox-input:checked + .checkbox-custom::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 5px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.checkbox-text {
    color: light-dark(#444, #aaa);
}

.form-actions {
    display: flex;
    gap: 12px;
    margin-top: 8px;
}

.btn-secondary {
    flex: 1;
    padding: 12px 16px;
    border: 1px solid light-dark(#e5e5e5, #333);
    background: transparent;
    color: light-dark(#666, #aaa);
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-secondary:hover {
    background: light-dark(rgba(0, 0, 0, 0.05), rgba(255, 255, 255, 0.1));
    color: light-dark(#111, #fff);
}

.btn-primary {
    flex: 1;
    padding: 12px 16px;
    border: none;
    background: light-dark(#ace715, #ace715);
    color: white;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-primary:hover:not(:disabled) {
    background: light-dark(#9bd413, #9bd413);
}

.btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.error-message {
    margin-top: 12px;
    padding: 10px 12px;
    background: rgba(176, 0, 32, 0.1);
    border: 1px solid rgba(176, 0, 32, 0.3);
    border-radius: 8px;
    color: #b00020;
    font-size: 14px;
}

@media (max-width: 480px) {
    .contact {
        padding: 12px;
    }
    
    .contact-icon {
        width: 35px;
        height: 35px;
    }
    
    .contact-link {
        font-size: 14px;
    }

    .modal-content {
        padding: 20px;
        margin: 10px;
    }

    .form-actions {
        flex-direction: column;
    }
}
</style>
